import { createContext, useContext } from 'react';

import { AppointmentState } from './types';

const AppointmentContext = createContext<Nullable<AppointmentState>>(null);

const useAppointmentContext = () => {
  const state = useContext(AppointmentContext);

  if (!state) {
    throw new Error(
      'useAppointmentContext must be used within an AppointmentProvider'
    );
  }

  return state;
};

export { AppointmentContext, useAppointmentContext };
